<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white p-6 rounded-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto">
      <h2 class="text-lg font-bold mb-4">Seleccionar producto</h2>
      <input
        v-model="busqueda"
        placeholder="Buscar producto por nombre"
        class="w-full mb-4 border px-3 py-2 rounded"
      />
      <div v-if="productosFiltrados.length === 0" class="text-sm text-gray-500">Sin coincidencias.</div>
      <ul class="space-y-2">
        <li
          v-for="producto in productosFiltrados"
          :key="producto.id_producto"
          class="border rounded px-3 py-2 flex justify-between items-center hover:bg-gray-50"
        >
          <div>
            <div class="font-medium">{{ producto.nombre }}</div>
            <div class="text-sm text-gray-600">Disponibles: {{ producto.disponibles }}</div>
          </div>
          <button
            @click="$emit('ver-unidades', producto)"
            class="text-sm bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
          >
            Ver unidades
          </button>
        </li>
      </ul>
      <div class="mt-6 text-right">
        <button @click="$emit('cerrar')" class="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400">Cerrar</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'BuscadorProducto',
  data() {
    return {
      busqueda: '',
      productos: []
    }
  },
  computed: {
    productosFiltrados() {
      const f = this.busqueda.toLowerCase();
      return this.productos.filter(p =>
        p.nombre && p.nombre.toLowerCase().includes(f)
      );
    }
  },
  mounted() {
    this.cargarProductos();
  },
  methods: {
    async cargarProductos() {
      try {
        const res = await axios.get('/api/almacen/productos/disponibles');
        this.productos = res.data;
      } catch (err) {
        console.error('Error al obtener productos disponibles:', err);
      }
    }
  }
}
</script>
